import { render, staticRenderFns } from "./CustomPopup.vue?vue&type=template&id=06188620&"
import script from "./CustomPopup.vue?vue&type=script&lang=ts&"
export * from "./CustomPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports